import { Dealer, Installer } from "core/services/installers/installers.models";

export type SearchResultItem = {
  type: SearchResultType;
  address: string;
  mobile: string;
  email: string;
  tel: string;
  state: string;
  name: string;
  coords: google.maps.LatLngLiteral;
}

const isDealer = (item: any) => {
  const dealer = item as Dealer;
  return dealer.contact !== undefined && dealer.location !== undefined;
}

const isInstaller = (item: any) => {
  const installer = item as Installer;
  return installer.physicalAddress !== undefined && installer.mobileNo !== undefined;
}

export enum SearchResultType {
  Dealer = "dealer",
  Installer = "installer"
}

const getCoordinates = (latitude: number, longitude: number) => {
  const coords: google.maps.LatLngLiteral = {
    lat: latitude,
    lng: longitude
  };

  return coords;
}

//Note: the api is returning a lat and lng of 0.0, 0.0 for most installers/dealers

const convertDealer = (dealer: Dealer): SearchResultItem => {
  const { contact, location } = dealer;
  const coords = getCoordinates(location?.latitude, location?.longitude);

  return {
    type: SearchResultType.Dealer,
    address: location?.fullAddress,
    mobile: contact?.mobile1,
    email: contact?.emailAddress,
    tel: contact?.telephone,
    state: location?.state,
    name: dealer?.name,
    coords: coords
  } as SearchResultItem;
}

const convertInstaller = (installer: Installer): SearchResultItem => {
  const coords = getCoordinates(installer?.latitude, installer?.longitude);

  return {
    type: SearchResultType.Installer,
    address: installer.physicalAddress,
    mobile: installer.mobileNo,
    email: installer.emailId || (installer as any).emailID,
    tel: installer.telephone,
    state: installer.cityName,
    name: installer.installerName,
    coords: coords
  } as SearchResultItem;
}

export const convert = (item: Installer | Dealer) => {
  if (isDealer(item)) {
    return convertDealer(item as Dealer);
  }

  if (isInstaller(item)) {
    return convertInstaller(item as Installer);
  }

  return null;
}

export const convertAll = (items: (Installer | Dealer)[]) => {
  let results = items.map(convert).filter(x => x !== null) as SearchResultItem[];
  filterAndSort(results);
  return results;
}

export const filterAndSort = (items: SearchResultItem[]) => {
  items.filter(x => x.name?.length ?? false).sort((a, b) => a.name.localeCompare(b.name));
}
